import React from 'react';
import BlogsEmbed from '../BlogsEmbed';
import GatedBlogsOverlay from './GatedBlogsOverlay';

export default function GatedBlogs() {
	return (
		<section className="relative mb-20">
			<div className="opacity-50">
				<BlogsEmbed isGated={true} />
			</div>
			<div className="message-overlay top-10">
				<GatedBlogsOverlay />
			</div>
		</section>
	);
}
